class MyCustomException extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'MyCustomException';
  }
}

export { MyCustomException };
